// extracted by mini-css-extract-plugin
export default {"productGrid":"F1-z","centerLink":"G1-z","productSection":"H1-z","item":"I1-z","ctaButton":"J1-z"};